import { render } from "./BookPage.vue?vue&type=template&id=146fb722"
import script from "./BookPage.vue?vue&type=script&lang=js"
export * from "./BookPage.vue?vue&type=script&lang=js"

import "./BookPage.vue?vue&type=style&index=0&id=146fb722&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__